import { Component, ElementRef, inject, input, output } from '@angular/core';
import { AppOrientation } from '@legacy-models/strapi/AppOrientation';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'oke-orientation',
  imports: [SvgIconComponent],
  templateUrl: './orientation.html',
  styleUrl: './orientation.scss'
})
export class Orientation {
  readonly $content = input.required<AppOrientation>({ alias: 'content' });
  readonly clear = output<number>();
  isMouseDown = false;
  elemWidth: number;
  elemHeight: number;
  dragStartX = 0;
  dragStartY = 0;
  currentX: number;
  currentY: number;
  private readonly _el = inject(ElementRef<HTMLElement>);

  clearAppOrientation(): void {
    this.clear.emit(this.$content().id);
  }

  dragStart(mouseDownEvt: MouseEvent): void {
    const { x, y } = mouseDownEvt;
    this.isMouseDown = true;
    this.dragStartX = x;
    this.dragStartY = y;
    this.currentX = parseInt(window.getComputedStyle(this._el.nativeElement).getPropertyValue('--x')) || 50;
    this.currentY = parseInt(window.getComputedStyle(this._el.nativeElement).getPropertyValue('--y')) || 50;
  }

  dragMove({ x, y }: MouseEvent): void {
    if (!this.isMouseDown) {
      return;
    }
    const isPositiveX = x > this.dragStartX;
    const isPositiveY = y > this.dragStartY;
    const changeXPct = isPositiveX
      ? ((x - this.dragStartX) / window.innerWidth) * 100
      : -(((this.dragStartX - x) / window.innerWidth) * 100);
    const changeYPct = isPositiveY
      ? ((y - this.dragStartY) / window.innerHeight) * 100
      : -(((this.dragStartY - y) / window.innerHeight) * 100);
    this._el.nativeElement.style.setProperty('--x', (this.currentX + changeXPct).toFixed(2) + '%');
    this._el.nativeElement.style.setProperty('--y', (this.currentY + changeYPct).toFixed(2) + '%');
  }

  dragEnd(): void {
    this.isMouseDown = false;
  }
}
